import React, { useRef, useEffect, useMemo, useCallback } from 'react'
import { connect } from 'react-redux'
import { useUpdateAtom } from 'jotai/utils'
import isEqual from 'lodash/isEqual'
import forEach from 'lodash/forEach'
import { number as numberFormatter } from 'loankeeper-common/helpers/formatters'
import { getInstance, getLocaleText, reduceFilterModel, removeFilterColumn, sortNoneColumn } from '../store'
import { ContextMenu } from './ContextMenu'
import { setColumnVisibilityAtom, setAllColumnsVisibleAtom } from './atoms/visibilityAtoms'
import { setColumnWidthAtom } from './atoms/widthAtoms'
import { setColumnPositionAtom } from './atoms/positionAtoms'
import { useGridIdentity } from './GridIdentityProvider'

const config = { childList: true, subtree: true }
@connect(
  (state, props) => ({
    filterModel: props.persistedFilterModel || getInstance(state, props.instanceName).filterModel,
  }),
  { reduceFilterModel, removeFilterColumn, sortNoneColumn },
)
class Whatever extends React.Component {
  state = {
    sortModel: {},
  }
  api = null

  componentDidUpdate(prevProps) {
    if (prevProps.iRowData?.length === 0 && this.props.iRowData?.length > 0) {
      this.setupFilter()
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  postProcessPopup(params) {
    if (params.type !== 'columnMenu') {
      return
    }
    setTimeout(() => {
      let nodes = params.ePopup.querySelectorAll('a')
      for (const node of nodes) {
        node.removeAttribute('href') //csp scrip-src 'self' javascript:void(0) fix
      }
    })
  }

  onGridReady = (params) => {
    const {
      instanceName,
      iOnGridReady,
      defaultSelectionsOnGridReady,
      persSelecRowOnGridReady,
      persistSelRowVisOnGridReady,
      setGridApi,
    } = this.props

    this.api = params.api
    setGridApi(instanceName, params)

    // this.api.toolPanelComp.setVisible(true)

    //grid error
    if (iOnGridReady) {
      iOnGridReady(params)
    }

    defaultSelectionsOnGridReady(params)
    persSelecRowOnGridReady(params)
    persistSelRowVisOnGridReady(params)

    this.reviveFilter()
  }

  onRowSelected = (...args) => {
    if (this.props.iOnRowSelected != null) {
      this.props.iOnRowSelected(...args)
    }
  }

  onSelectionChanged = (...args) => {
    this.props.persSelecRowOnSelectionChanged(...args)
  }

  getSortModel = () => {}

  lastSortModel = null

  onSortChanged = (sortEvent) => {
    if (sortEvent.source === 'uiColumnSorted') {
      const { instanceName, filterModel, onFiltered, customId, enableMultiSort } = this.props

      // const sortModel = sortEvent.api.getSortModel()
      // const sortedColumn = sortModel[0]
      // console.log(sortEvent.columnApi.getColumnState())
      const sortModel = sortEvent.columnApi.getColumnState().filter((s) => s.sort != null)

      // const sortedColumn = sortModel[sortModel.length - 1] || undefined
      const sortedColumn = sortModel[0]

      // if (sortModel) {
      //   const curretSortModel = sortEvent.columnApi.getColumnState()
      //   const mergeSortModel = curretSortModel.map(o1 => sortModel.find(o2 => o2.colId === o1.colId) || o1)
      //   sortEvent.columnApi.applyColumnState(mergeSortModel)
      // }
      this.props.persistSortedColumnOnSortChanged(sortedColumn)

      if (!isEqual(this.lastSortModel, sortModel) && enableMultiSort) {
        sortEvent.columnApi.applyColumnState(sortModel)
        this.lastSortModel = sortModel
      }

      if (sortedColumn != null && filterModel[sortedColumn.colId]) {
        this.props.removeFilterColumn(instanceName, sortedColumn.colId, customId)

        // filter was removed, so upper commponents should be notified
        if (this.api && typeof onFiltered === 'function') {
          const filteredData = []
          this.api.forEachNodeAfterFilter((item) => filteredData.push(item.data))
          onFiltered(filteredData)
        }
      }

      this.reviveFilter()
    }
  }

  onRangeSelectionChanged = (e) => {
    this.props.statusBarRangeSelectionOnRangeSelectionChanged(e)
  }

  setupFilter = () => {
    this.timeout = setTimeout(() => {
      this.reviveFilter()
      this.timeout = null
    }, 500)
  }

  getAgGridReactProps() {
    const {
      columnDefs,
      iRowData,

      getContextMenuItems,

      iEnableColumnsResize,

      iEnableColumnsOrder,
      suppressDragLeaveHidesColumns,

      iDeltaRowDataMode,
      iGetRowNodeId,

      iEnableRowSelection,
      iOnRowDoubleClicked,

      iEnableSorting,

      iGetRowStyle,
      iGetRowClass,

      onCellClicked,

      navigateToNextCell,

      showToolPanel,

      enableFilter,

      statusBarOn,
      isApplyGeneralNumberFormat,
      iGetContextMenuItems,
      enableMultiSort,
    } = this.props

    const agGridReactProps = {
      rowData: iRowData,

      columnDefs,

      onGridReady: this.onGridReady,

      enableColResize: iEnableColumnsResize,
      resizable: iEnableColumnsResize,
      onColumnResized: this.onColumnResized,
      postProcessPopup: this.postProcessPopup,

      onColumnMoved: this.onColumnMoved,
      suppressMovableColumns: !iEnableColumnsOrder,
      suppressDragLeaveHidesColumns,

      immutableData: iDeltaRowDataMode,

      onColumnVisible: this.onColumnVisible,

      defaultColDef: {
        sortable: iEnableSorting,
        resizable: iEnableColumnsResize,
        filter: false,
        suppressKeyboardEvent: ({ event }) => {
          if (event.key === 'Tab') {
            event.preventDefault()
          }
          // console.log(params)
        },
      },
      enableSorting: iEnableSorting,

      suppressMultiSort: !enableMultiSort,
      suppressColumnVirtualisation: true,
      suppressNoRowsOverlay: true,
      showToolPanel: false,
      toolPanelSuppressRowGroups: true,
      toolPanelSuppressValues: true,
      toolPanelSuppressPivotMode: true,
      suppressTabbing: true,
      localeText: getLocaleText(),
      enableFilter,
      api: this.api,
      iEnableRowSelection,
      iGetContextMenuItems,
      toolPanelSuppressSideButtons: true,
    }

    // Update columnDefs add valueFormatter if not defined and iRowData[0] is Not NAN
    if (isApplyGeneralNumberFormat) {
      if (iRowData && iRowData.length > 0 && columnDefs && columnDefs.length > 0) {
        const firstRow = iRowData[0]

        const lastRow = iRowData[iRowData.length - 1]
        for (let i = 0; i < columnDefs.length; i++) {
          if (columnDefs[i].field && typeof firstRow[columnDefs[i].field] === 'number') {
            if (!columnDefs[i].valueFormatter) {
              if (Number.isInteger(firstRow[columnDefs[i].field]) && Number.isInteger(lastRow[columnDefs[i].field])) {
                columnDefs[i] = {
                  ...columnDefs[i],
                  cellStyle: {
                    textAlign: 'right',
                  },
                }
              } else {
                columnDefs[i] = {
                  ...columnDefs[i],
                  valueFormatter: ({ value }) => numberFormatter(value),
                  cellStyle: {
                    textAlign: 'right',
                  },
                }
              }
            }
          }
        }
      }
    }

    if (getContextMenuItems != null) {
      agGridReactProps.getContextMenuItems = getContextMenuItems
    }

    if (iGetRowNodeId != null) {
      agGridReactProps.getRowNodeId = iGetRowNodeId
    }

    agGridReactProps.onFilterChanged = this.handleFilterChanged

    if (iEnableRowSelection) {
      agGridReactProps.rowSelection = 'single'

      agGridReactProps.onRowSelected = this.onRowSelected

      agGridReactProps.onSelectionChanged = this.onSelectionChanged

      agGridReactProps.onSortChanged = this.onSortChanged

      if (iOnRowDoubleClicked != null) {
        agGridReactProps.onRowDoubleClicked = iOnRowDoubleClicked
      }

      agGridReactProps.navigateToNextCell = navigateToNextCell
    }

    if (iGetRowStyle != null) {
      agGridReactProps.getRowStyle = iGetRowStyle
    }

    if (iGetRowClass != null) {
      agGridReactProps.getRowClass = iGetRowClass
    }

    if (onCellClicked != null) {
      agGridReactProps.onCellClicked = onCellClicked
    }

    if (statusBarOn) {
      agGridReactProps.onRangeSelectionChanged = this.onRangeSelectionChanged
      agGridReactProps.enableRangeSelection = true
      agGridReactProps.enableStatusBar = true
      agGridReactProps.alwaysShowStatusBar = true
    }

    return agGridReactProps
  }

  reviveFilter = () => {
    if (this.api && this.props.enableFilter) {
      this.api.setFilterModel(this.props.filterModel)
    }
  }

  handleFilterChanged = () => {
    const { enableFilter, instanceName, onFiltered, customId } = this.props

    if (!this.api) {
      return
    }

    if (enableFilter) {
      const filterModel = this.api.getFilterModel()

      this.props.reduceFilterModel(instanceName, filterModel, customId)

      const input = document.querySelector('.ag-filter-filter')
      if (input) {
        input.focus()
      }
    }

    if (typeof onFiltered === 'function') {
      const filteredData = []
      this.api.forEachNodeAfterFilter((item) => filteredData.push(item.data))
      onFiltered(filteredData)
    }
  }

  render() {
    const { instanceName } = this.props
    return <WhateverF {...this.getAgGridReactProps()} instanceName={instanceName} reviveFilter={this.reviveFilter} />
  }
}

const WhateverF = (props) => {
  const identity = useGridIdentity()
  const identityRef = useRef(identity)

  useEffect(() => {
    identityRef.current = identity
  }, [identity])

  const setColumnVisibility = useUpdateAtom(setColumnVisibilityAtom)
  const setAllColumnsVisible = useUpdateAtom(setAllColumnsVisibleAtom)

  const columnsUpdateBufferRef = useRef({})

  // const isListenerSetRef = useRef(false)
  // const isToolPanelRendered = useRef(false)
  const columnsApiRef = useRef(null)

  const observer = useMemo(
    () =>
      new MutationObserver((mutationsList, observer) => {
        let closed = false
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            mutation.removedNodes.forEach((node) => {
              if (node.classList.contains('ag-virtual-list-item')) {
                closed = true
                return
              }
            })
          }
          observer.disconnect()
        }
        if (closed && columnsApiRef.current) {
          const allDisplayedColumns = columnsApiRef.current.getAllDisplayedColumns()
          const allColumns = columnsApiRef.current.getAllGridColumns()

          const resetColumnVisibility = allDisplayedColumns.every((column) => {
            return column.colDef.headerName === 'X' || column.colDef.headerName === ''
          })

          if (resetColumnVisibility && allColumns.length >= 1) {
            setAllColumnsVisible({ id: identityRef.current })
          } else {
            forEach(columnsUpdateBufferRef.current, (columnVisibilityUpdate) => {
              setColumnVisibility(columnVisibilityUpdate)
              props.reviveFilter()
            })
          }
          observer.disconnect()
        }
      }),
    [],
  )

  const handleColumnVisibilityChange = useCallback((params) => {
    if (document.querySelector('.ag-popup')) {
      observer.observe(document.querySelector('.ag-popup'), config)
    }
    // if (params.source === 'toolPanelUi' || params.source === 'columnMenu') {
    // isToolPanelRendered.current = true
    // const {
    //   visible,
    //   column: {
    //     colDef: { field },
    //   },
    // } = params;
    const visible = params?.visible
    // const field = params?.column?.colDef?.field
    const fields = params?.columns?.map((col) => col.colDef.field)

    const { columnApi } = params
    columnsApiRef.current = columnApi

    // const handleToolPanelClose = (e) => {
    //   const allDisplayedColumns = columnApi.getAllDisplayedColumns()
    //   const allColumns = columnApi.getAllGridColumns()
    //   console.log(e.target)
    //   const isClickedOutsideToolPanel =
    //     e.composedPath().filter(({ className }) => className?.includes('ag-menu')).length === 0
    //   // const isToolPanelRendered = document.getElementsByClassName('ag-menu').length > 0

    //   if (isClickedOutsideToolPanel && isToolPanelRendered.current) {
    //     isToolPanelRendered.current = false
    //     isListenerSetRef.current = false
    //     const resetColumnVisibility = allDisplayedColumns.every((column) => {
    //       return column.colDef.headerName === 'X' || column.colDef.headerName === ''
    //     })

    //     if (resetColumnVisibility && allColumns.length > 1) {
    //       setAllColumnsVisible({ id: identity })
    //     } else {
    //       forEach(columnsUpdateBufferRef.current, (columnVisibilityUpdate) => {
    //         setColumnVisibility(columnVisibilityUpdate)
    //         props.reviveFilter()
    //       })
    //     }
    //     document.removeEventListener('click', handleToolPanelClose)
    //   }
    // }

    // if (!isListenerSetRef.current) {
    //   document.addEventListener(
    //     'click',
    //     handleToolPanelClose,
    //     { capture: true },
    //   )
    //   isListenerSetRef.current = true
    // }

    if (fields) {
      fields.forEach(
        (field) => (columnsUpdateBufferRef.current[`${identity}_${field}`] = { id: identity, field, visible }),
      )
    }
    // }
  }, [])

  const columnResizeRef = React.useRef()
  const resizeColumn = useUpdateAtom(setColumnWidthAtom)
  const handleColumnResize = useCallback(
    (params) => {
      // if (params.source === 'uiColumnResized') {
      if (params.column) {
        columnResizeRef.current = params.column
      }

      if (columnResizeRef.current) {
        const { colDef, actualWidth } = columnResizeRef.current

        if (params.finished) {
          resizeColumn({ id: identity, field: colDef.field, width: actualWidth })
        }
      }

      props.reviveFilter()
      // }
    },
    [props.reviveFilter],
  )

  const moveColumn = useUpdateAtom(setColumnPositionAtom)

  const handleColumnMoved = useCallback(
    (params) =>
      setTimeout(() => {
        // if (params.source === 'uiColumnMoved') {
        if (params.column) {
          const { colDef } = params.column
          moveColumn({
            id: identity,
            field: colDef.field,
            position: !!props.iGetContextMenuItems ? params.toIndex : params.toIndex + 1,
          })
        }

        props.reviveFilter()
        // }
      }, 100),
    [props.iGetContextMenuItems, props.reviveFilter],
  )

  return (
    <ContextMenu
      {...props}
      onColumnResized={handleColumnResize}
      onColumnMoved={handleColumnMoved}
      onColumnVisible={handleColumnVisibilityChange}
    />
  )
}

export default Whatever
